const YOUTUBE_URL_REGEX = /(?:youtube(?:-nocookie)?\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
const TWITTER_STATUS_URL_REGEX = /(?:twitter|x)\.com\/.+\/status\/(\d+)/;
const INSTAGRAM_CLIENT_ACCESS_TOKEN = '464777950352006|e471ba98663028dc5282c7ed498a5ded';

export function extractYoutubeVideoId(url) {
    if (!url || typeof url !== 'string') {
        return null;
    }

    const videoIdMatch = url.match(YOUTUBE_URL_REGEX);

    return (videoIdMatch && videoIdMatch[1]) || null;
}

export function findYoutubeIframe(domNode) {
    if (
        domNode
        && domNode.name === 'iframe'
        && domNode.attribs
        && domNode.attribs.src
        && domNode.attribs.src.indexOf('youtube') >= 0
    ) {
        return domNode;
    }

    if (domNode && domNode.children && domNode.children[0]) {
        return findYoutubeIframe(domNode.children[0]);
    }

    return false;
}

export function extractTweetId(url) {
    if (!url || typeof url !== 'string') {
        return null;
    }

    const tweetIdMatch = url.match(TWITTER_STATUS_URL_REGEX);

    return (tweetIdMatch && tweetIdMatch[1]) || null;
}

export function stripQueryString(url) {
    if (!url || typeof url !== 'string') {
        return null;
    }

    return url.split('?')[0];
}

export function getInstagramEmbedProps(url) {
    if (!url || typeof url !== 'string') {
        return null;
    }

    return {
        url,
        hideCaption: false,
        clientAccessToken: INSTAGRAM_CLIENT_ACCESS_TOKEN,
    };
}
